// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { dismissRealityCheckMessage } from '../../actions/regulation';
import useMergeProps from '../../hooks/useMergeProps';

import RealityCheckModal from './RealityCheckModal';
import selectRealityCheckModalProps from './RealityCheckModal.selector';

type RealityCheckModalContainerProps = {
  className?: string;
};

const RealityCheckModalContainer = (ownProps: RealityCheckModalContainerProps) => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(selectRealityCheckModalProps);

  const onClose = useCallback(() => {
    dispatch(dismissRealityCheckMessage());
  }, [dispatch]);

  const otherProps = useMemo(() => ({ onClose }), [onClose]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <RealityCheckModal {...enhancedProps} />;
};

export default RealityCheckModalContainer;
